import { render, staticRenderFns } from "./display.vue?vue&type=template&id=6182bfc0&scoped=true&"
import script from "./display.vue?vue&type=script&lang=js&"
export * from "./display.vue?vue&type=script&lang=js&"
import style0 from "./display.vue?vue&type=style&index=0&id=6182bfc0&lang=scss&scoped=true&"
import style1 from "./display.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6182bfc0",
  null
  
)

export default component.exports